import { Box, Stack, Typography, useMediaQuery, useTheme } from "@mui/material";
import { Icons } from "../../assets/icon";
import AccessTimeIcon from "@mui/icons-material/AccessTime";

interface CoinTimeRatingProps {
  chipAmount: number;
  rating: string;
  reviews: string;
  duration: number;
  isHovered: boolean;
}

export default function CoinTimeRating(props: CoinTimeRatingProps) {
  const { chipAmount, rating, reviews, duration, isHovered } = props;

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Stack
      spacing={1}
      sx={{
        mb: isHovered ? 2 : 1,
        flexWrap: "wrap",
        rowGap: { xs: 0.5, sm: 1, md: 2 },
        alignItems: "flex-start",
      }}
    >
      <Box
        sx={{
          display: "flex",
          padding: isMobile
            ? "0px"
            : "var(--spacing-1x) var(--spacing-2x) var(--spacing-1x) var(--spacing-1x)",
          alignItems: "center",
          gap: " var(--spacing-1x)",
          borderRadius: "var(--spacing-8x)",
          background: { xs: "none", sm: "var(--primary-100)" },
          height: { xs: "auto", md: "28px" },
          flexWrap: "wrap",
          flexDirection: "row",
        }}
      >
        {/* coins */}
        <Box
          display="flex"
          flexDirection="row"
          alignItems="center"
          justifyContent="flex-start"
          gap="2px"
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "2px var(--spacing-1x)",
              gap: "var(--Spacing-1x)",
              borderRadius: "16px",
              background: "var(--neutralWhite)",
            }}
          >
            <Icons.Coin />
          </Box>
          <Typography
            sx={{
              font: "var(--body-xs)",
              color: "var(--neutral-1000)",
              fontSize: {
                xs: "10px",
                sm: "12px",
              },
            }}
          >
            {chipAmount}
          </Typography>
        </Box>
        {/* time duration */}
        <Box
          display="flex"
          flexDirection="row"
          alignItems="center"
          justifyContent="flex-start"
          gap="2px"
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "2px var(--spacing-1x)",
              gap: "var(--Spacing-1x)",
              borderRadius: "16px",
              background: "var(--neutralWhite)",
            }}
          >
            <AccessTimeIcon
              sx={{
                color: "var(--primary-600)",
                stroke: "1.33px",
                fontSize: {
                  xs: "13px !important",
                  sm: "13px !important",
                  md: "18px !important",
                },
              }}
            />
          </Box>
          <Typography
            sx={{
              alignItems: "flex-start",
              font: "var(--body-xs)",
              color: "var(--neutral-1000)",
              fontSize: {
                xs: "10px",
                sm: "12px",
              },
            }}
          >
            {`${duration} ${isMobile ? "" : "min"}`}
          </Typography>
        </Box>
        {/* rating */}
        <Box
          ml="2px"
          sx={{
            display: "flex",
            padding: "2px 8px 2px var(--spacing-1x)",
            justifyContent: "center",
            alignItems: "center",
            gap: "var(--spacing-1x)",
            borderRadius: "16px",
            background: "var(--neutralWhite)",
            color: "var(--neutral-1000)",
            font: "var(--semibold-sm)",
            marginLeft: "0px",
            "& .css-qwn5fn-MuiChip-root .MuiChip-icon": {
              marginLeft: "0px",
            },
          }}
        >
          <Icons.Rating
            height={isMobile ? "14px" : "16px"}
            width={isMobile ? "14px" : "16px"}
          />
          <Typography
            sx={{
              color: "var(--neutral-1000)",
              font: "var(--semibold-xs)",
              fontSize: {
                xs: "10px",
                md: "12px",
              },
              //   paddingTop: isMobile ? "2px" : "",
            }}
          >
            {rating}
          </Typography>
        </Box>
      </Box>
    </Stack>
  );
}
